export const ACCORDION_TRANSITION_DURATION = 200;
